import React, { useState } from "react";
import { IconDotsVertical } from "@tabler/icons-react";
import { TransactionHeaderSection, TransactionHeaderText } from "./styles";
import { COLORS } from "@app/constants/STYLES";
import { useTranslation } from "react-i18next";
import { NormalDropdown } from "@app/components/Common";

const TransactionHeader = () => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState("1");
  const dropdownList = [
    t("turnOffMargin"),
    t("spotTradingFees"),
    t("marginSpecifications"),
  ];
  return (
    <TransactionHeaderSection>
      <TransactionHeaderText>{t("spot")}</TransactionHeaderText>

      <NormalDropdown
        setSelected={setSelected}
        selected={selected}
        data={dropdownList}
        icon={<IconDotsVertical size={20} color={COLORS.grayWhite} />}
        style={{
          marginLeft: -110,
          width: 150,
        }}
        btnStyle={{
          backgroundColor: COLORS.gray,
          paddingBlock: 2,
        }}
      />
    </TransactionHeaderSection>
  );
};

export default React.memo(TransactionHeader);
